import { ClientsTable } from "../../components/Client"
import { useClientsData } from "../../utils/hooks/useClientsData"

export const Clients = () => {
  const { filteredClients } = useClientsData()

  return (
    <div className="h-full flex flex-col space-y-6">
      {/* Contenu avec scroll */}
      <div className="flex-1 overflow-y-auto space-y-6">
        {/* Liste des clients */}
        <ClientsTable clients={filteredClients} />
      </div>
    </div>
  )
}
